import { ParserContentData } from '@libs';

export const normalizeEducationVideo = (data, category = '') => {
  const items = category
    ? ParserContentData.getItemsArrayFromBlock(data, { blockKey: category })
    : ParserContentData.getItemsArrayFromAllBlock(data, { groupKey: 'education_videos' });

  return items.map((item) => {
    const { id, formData } = ParserContentData.getDataFromItem(item);
    const { title, cover, youtube } = formData;

    return { id, title, cover, youtube };
  });
};

export const normalizeEducationButtons = (data) => {
  const blocks = ParserContentData.getBlocksArray(data, { groupKey: 'education_buttons' });

  return blocks.map((block) => {
    const item = block.items ? block.items.items : {};

    const { formData } = ParserContentData.getDataFromItem(item);

    return {
      id: block.id,
      caption: block.caption,
      content: formData.content,
    };
  });
};

export const normalizeEducationInstructions = (data) => {
  const items = ParserContentData.getItemsArray(data, { groupKey: 'education_instructions', blockKey: 'links' });

  return items.map((item) => {
    const { id, formData } = ParserContentData.getDataFromItem(item);
    const { title, description, cover, link } = formData;

    return { id, title, description, cover, link };
  });
};

export const normalizeEducationCourses = (data, locale) => {
  const blockKey = `education_courses_${locale}`;
  const currentLangItems = ParserContentData.getItemsArray(data, { groupKey: 'education_courses', blockKey: blockKey });
  // если нет для текущего языка то берем для en
  const items = currentLangItems.length
    ? currentLangItems
    : ParserContentData.getItemsArray(data, { groupKey: 'education_courses', blockKey: 'education_courses_en' });

  return items.map((item) => {
    const { id, formData } = ParserContentData.getDataFromItem(item);
    const { logo, description, cover, link } = formData;

    return { id, logo, description, cover, link };
  });
};
